// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "@PayPlans/views/Layers/Departments/Technicians";

const POSITION = "Service Technician";

export default function Technicians() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	return (
		<PageLayer title={"Service Technician Pay Plans"} icon={Icon}>
			<Layer position={POSITION} defaultSections={["default"]} />
		</PageLayer>
	);
}
